<template>
    <component 
        :is="componentName"
        :to="disabled ? null : to"
        class="btn_default" 
        :class="{ icon, outline, disabled, noborder, inverted, red, like_text, [`size-${size}`]: true}"
        @click="clickHandler">
        <font-awesome-icon
            v-if="icon !== null"
            class="icon"
            :icon="icon"
        ></font-awesome-icon>
        <slot v-else></slot>
    </component>
</template>

<script>
export default {
    props: {
        icon: { //Some fa icon
            default: null,
        },
        outline: {
            type: Boolean,
            default: false,
        },
        to: {
            type: [String, Object],
            default: null,
        },
        size: {
            type: String,
            default: 'normal',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        inverted: {
            type: Boolean,
            default: false,
        },
        red: {
            type: Boolean,
            default: false,
        },
        noborder: {
            type: Boolean,
            default: false,
        },
        like_text: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        componentName() {
            return this.to === null ? 'div' : 'router-link';
        },
    },
    methods: {
        clickHandler() {
            if (!this.disabled) {
                this.$emit('click');
            }
        },
    },
};
</script>

<style lang="scss">
    @import '../../styles/rem';
    $outlineColor: rgba($color: #4663AB, $alpha: 0);

    .btn_default {
        font-family: 'Proxima Nova', sans-serif;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: rem(18);
        line-height: rem(26);
        background-color: #4663AB;
        border-radius: rem(4);
        text-align: center;
        font-weight: bold;
        color: white;
        min-height: rem(48);
        min-width: rem(48);
        user-select: none;
        white-space: nowrap;

        @include on-mobile {
            border-radius: mrem(4);
            min-height: mrem(48);
            min-width: mrem(48);
            font-size: mrem(16);
            line-height: mrem(20);
        }

        &.disabled {
            cursor: default;
            opacity: 0.5;
            pointer-events: none;
        }

        &.text--bold {
            font-weight: bold;
            padding: rem(14);
        }

    &.outline {
        border-width: rem(1);
        border-style: solid;
        border-color: #4663AB;
        color: #4663AB;
        background-color: $outlineColor; 

        &:hover {
            color: #4663AB!important;
            background-color: #E6F1FD!important;
        }
    }

    &.inverted {
        border-width: rem(1);
        border-style: solid;
        border-color: #fff;
        color: #fff;
        background-color: transparent; 
    }

    &.noborder {
        border: none;
    }

    &.like_text {
        background: transparent;
    }

    &.success, &.green {
        $color: #68C87A;
        $colorDisabled: rgba($color, $alpha: 0.5);

        background-color: $color;
        &.outline {
            border-width: 1px;
            border-style: solid;
            border-color: #4663AB;
            color: #4663AB;
            background-color: $outlineColor;
        }

        &.disabled {
            background-color: $colorDisabled;

            &.outline {
                border-color: $colorDisabled;
                color: $colorDisabled;
                background-color: $outlineColor;
            }
        }
    }

    &.grey {
        $color: #D2D5D9;
        $colorDisabled: rgba($color, $alpha: 0.5);

        background-color: $color;
        &.outline {
            border-color: $color;
            color: $color;
            background-color: $outlineColor; 
        }

        &.disabled {
            background-color: $colorDisabled;

            &.outline {
                border-color: $colorDisabled;
                color: $colorDisabled;
                background-color: $outlineColor;
            }
        }
    }

    &.red {
        $color:  #D1004A;
        $colorDisabled: rgba($color, $alpha: 0.5);

        background-color: $color;
        &.outline {
            border-color: $color;
            color: $color;
            background-color: $outlineColor;
        }

        &.disabled {
            background-color: $colorDisabled;

            &.outline {
                border-color: $colorDisabled;
                color: $colorDisabled;
                background-color: $outlineColor;
            }
        }
    }

    &.white-blue {
        $color: #93C2E8;
        $colorDisabled: rgba($color, $alpha: 0.5);

        background-color: #FFFFFF;
        &.outline {
            border-color: $color;
            color: $color;
            background-color: #FFFFFF;
        }

        &.disabled {
            &.outline {
                border-color: $colorDisabled;
                color: $colorDisabled;
                background-color: $outlineColor;
            }
        }
    }

    &.simple-white-button {
        color: #4663AB;
        background-color: #ffffff;
        border-color: transparent;

        &:hover {
            border-color: #4663AB;
        }
    }

    &.simple-pink-button {
        color: #EF627D;
        background-color: #ffffff;
        border-color: transparent;

        &:hover {
            border-color: #EF627D;
        }
    }

    &.icon {
        min-width: 0;
        min-height: 0;
        border-radius: 50%;
        color: white;

        &.white-blue {
            color: #93C2E8;

            &:hover {
                color: #FFFFFF;
            }
        }

        &.size-normal {
            width: rem(40);
            height: rem(40);

            @include on-mobile {
                height: mrem(40);
                width: mrem(40);
            }
        }

        &.size-small {
            width: rem(36);
            height: rem(36);

            @include on-mobile {
                height: mrem(36);
                width: mrem(36);
            }
        }
    }
}
</style>
